import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../services/service.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-hotspot',
  templateUrl: './hotspot.component.html',
  styleUrls: ['./hotspot.component.css']
})
export class HotspotComponent implements OnInit {

  selectall:boolean=false;
  visible:boolean=false;
  userdata:any;
  count:any=0;
  actions:boolean=false;
  show:boolean=false;
  
  value:any[]=[{
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'




  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  }
  ,
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  },
  {
    "uni-id":'1',
    "userID":'7010159885',
    "acc":'Active',
    'name':'Muthu Kumar V',
    'Quota':'No Limit',
    'Today':'12.36 GB',
    'weel':'76.84 GB',
      'month':'308.41 GB',
      'life':'308.41 GB',
      'top':'-',
      'top-v':'-',
      'm-u':'Mar 01,2025 11:25Am',
      'Quota1':'No Limit',
      'Today1':'16:15:00',
      'week':'101:56:23',
      'm':'271:20:1',
      'l':'271:20:01',
      't':'0',
      'v':'0',
      'r':'18',
      'ts':'30',
      'l-l':'mar 12,2025 16:08',
      'sid':'Default-default'

  }


];
constructor(private ServerService: ServiceService,private http: HttpClient,private modalService: NgbModal){}
  ngOnInit(): void {
  }
 openLarge(content) {
    this.modalService.open(content, {
      size: 'lg'
    });
   
  }
  
  // openSmall(content) {
  //   this.modalService.open(content, {
  //     size: 'sm'
  //   });
  // }
  
  openSmall(content: any) {
    this.modalService.open(content, { windowClass: 'custom-modal' });
  }
  
  // private getDismissReason(reason: any): string {
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return `with: ${reason}`;
  //   }
  // }
  
  Delete()
  {
    Swal.fire({
      title: 'Are you sure to Delete?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    });
  }
  
  display()
  {
   this.visible=!this.visible;
  }
  child()
  {
    for(let i=0;i<this.value.length;i++)
    {
      if(this.value[i])
      {
        this.value[i].selected=this.selectall;
      }
    }
  }
  update(item:any)
  {
    if(item.selected)
    {
      alert("You are selected One item");
      this.count++;
      console.log(this.count);
      if(this.count==this.value.length && this.count>=this.value.length )
        {
          this.selectall=true;
        }
        else if(this.count==this.value.length)
        {
          this.count=0;
        }
    }
    else
    {
      this.selectall=false;
      const index = item.selected.indexOf(item);
       item.selected.splice(index, 1);
       alert('deleted Succesfully');
    }

    
  }
  userclick()
  {
   this.show=!this.show;
 
  }

  openLargeview(content) {
    this.modalService.open(content, {
      size: 'lg'
    });
   
  }
}
